Vendd.Scripts.load(function () {
    var $form = $('.x-invoice-access-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        OrderCode: "",
        OrderPhone: "",
        reCaptchaCode: ""
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);
        var data = envelope.message.data;

        if (data.success) {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            var url = '/services/api/eInvoice/GetInvoiceDocumentUnauthorized?orderCode=' + formData.orderCode + '&orderPhone=' + formData.orderPhone;

            $('.js-download .download-button').attr("href", url);

            $('.js-download').show();

        } else {
            $('.js-error', $form).show();
        };

    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.InvoiceAccess.Messages.Submit(formData.orderCode, formData.orderPhone, formData.reCaptchaCode));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="orderCode"]', $form).val("");
        $('input[name="orderPhone"]', $form).val("");

        cf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val = cf.validate();

        if (val) {
            form.submit();
        }
    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('keyup', 'input[name]', function (e) {
        if (e.keyCode == 13) {

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "validationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {
        if (!captchaEnabled)
            return;
        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
            //accessibility fix
            $('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
        }
    };

    form.validateRecaptcha = function () {

        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;
        if (formData.reCaptchaCode) {
            $captchaContainer.find('.error-recaptcha').hide();
            res = true;
        }
        else {
            $captchaContainer.find('.error-recaptcha').show();
        }
        return res;
    };

    form.resetRecaptcha = function () {
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    }

    //init validation options
    var validationOptions = {
        orderCode: {
            required: 'ordercode-required'
        },
        orderPhone: {
            required: 'orderphone-required'
        },
    };

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox();
    }

    Vendd.MessageBus.subscribe(Vendd.InvoiceAccess.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.InvoiceAccess.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
});

